import api from "./api";

/**
 * Fetches all data required for the Overview page.
 */
export async function getOverview(outletUid) {

    try {

        const response = await api.get(

            "/api/v1/nextgo/overview",

            {

                params: {

                    outletUid,

                },

            }

        );

        return response.data;

    }

    catch (error) {

        console.error(

            "Failed to fetch overview:",

            error

        );

        throw error;

    }

}